import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  license: null
}

const userRoleSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    setLicense: (state, action) => {
      state.license = action.payload
    }
  }
})

export const { actions, reducer } = userRoleSlice
export const { setLicense } = actions
export default reducer
